import React, { useState, useEffect } from "react";
import { Button, Grid, Container } from "@mui/material";
import api from "../../globals/axios";
import CustomAppBar from "../../components/AppBar";
import { useTranslation } from "react-i18next";
import { CustomTitle } from "../../components/Custom/CustomTypography";
import { useLocation } from "react-router-dom";
import LoaderContainer from "../../components/LoaderContainer";
import CustomTextField from "../../components/Custom/CustomTextField";
import FileUpload from "../../components/Custom/FileUpload";
import useFormValidation from "../../components/Custom/FormValidation";
import { FpoMemberValidationSchema } from "../../components/Custom/ValidationSchema";
const validationSchema = FpoMemberValidationSchema();
export default function AddFPOMember() {
  const [formData, setFormData] = useState({});
  const location = useLocation();
  const [isEdit, setIsEdit] = useState(false);
  const searchParams = new URLSearchParams(location.search);
  const { errors, validate } = useFormValidation(formData, validationSchema);
  const fpoId = searchParams.get("fpoId");
  const [loading, setLoading] = useState(true);
  const { t } = useTranslation();

  useEffect(() => {
    if (fpoId) {
      fetchFpoData(fpoId);
      setIsEdit(true);
    } else {
      setLoading(false);
    }
  }, [isEdit]);
  const fetchFpoData = (fpoId) => {
    api
      .get(`/fpo/fpo_persona/${fpoId}`)
      .then((response) => {
        if (response && response.data) {
          const fpoData = response.data;
          setFormData(fpoData);
          setLoading(false);
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error fetching farm data:", error);
      });
  };

  const handleChange = (name, value) => {
    setFormData((prevData) => ({ ...prevData, [name]: value }));
    validate({ ...formData, [name]: value });
  };

  const onFileChange = (event) => {
    setFormData({ ...formData, [event.target.name]: event.target.files[0] });
    validate({ ...formData, [event.target.name]: event.target.files[0] });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    validate(formData);
    if (Object.keys(errors).length === 0) {
      const fileFields = ["aadhar_card", "pan_card"];
      const _formData = new FormData();
      for (const key in formData) {
        if (formData[key] instanceof FileList) {
          _formData.append(key, formData[key][0]);
        } else {
          if (fileFields.includes(key) && typeof formData[key] === "string")
            continue;
          _formData.append(key, formData[key]);
        }
      }
      const apiRequest = isEdit
        ? api.patch(`fpo/fpo_persona/${fpoId}/`, _formData)
        : api.post("fpo/add-fpo-persona/", _formData);

      apiRequest
        .then((response) => {
          console.log("Response from POST request:", response);
          alert("Member added successfully");
          window.location.href = "/fpo/members";
        })
        .catch((error) => {
          console.error("Error making POST request:", error);
        });
    } else {
      alert("Please fix the validation errors before submitting.");
    }
  };

  const fields = [
    {
      type: "text",
      label: t("Name"),
      name: "full_name",
    },
    {
      type: "tel",
      label: t("Mobile"),
      name: "mobile",
    },
    {
      type: "text",
      label: t("Aadhar Number"),
      name: "aadhar_number",
    },
    {
      type: "file",
      label: t("Upload Aadhar Card"),
      name: "aadhar_card",
      accept: ".pdf, .jpeg, .jpg, .heic, .png",
    },
    {
      type: "text",
      label: t("Pan Number"),
      name: "pan_number",
    },
    {
      type: "file",
      label: t("Upload Pan Card"),
      name: "pan_card",
      accept: ".pdf, .jpeg, .jpg, .heic, .png",
    },
    {
      type: "select",
      label: t("Member Type"),
      name: "designation",
      options: [
        { value: "FPO_DIRECTOR", label: t("Director") },
        { value: "FPO_CEO", label: t("CEO") },
      ],
    },
    {
      type: "text",
      label: t("Address"),
      name: "address",
      rows: 4,
    },
  ];

  return (
    <>
      <CustomAppBar />
      <LoaderContainer loading={loading}>
        <Container maxWidth="xs">
          <Grid
            container
            justify="center"
            direction="column"
            style={{ marginTop: "10px" }}
          >
            <CustomTitle>{t("Add FPO Member")}</CustomTitle>
            <form onSubmit={handleSubmit} style={{ marginTop: "20px" }}>
              <Grid container spacing={2}>
                {fields.map((field, index) => (
                  <Grid item xs={12} key={index}>
                    {field.type === "file" ? (
                      <FileUpload
                        label={field.label}
                        onChange={onFileChange}
                        name={field.name}
                        accept={field.accept}
                        error={errors[field.name]}
                        helperText={errors[field.name]}
                        edit={isEdit}
                        disabled={isEdit}
                        fileData={formData[field.name]}
                        documentId={formData.id}
                      />
                    ) : (
                      <CustomTextField
                        label={field.label}
                        name={field.name}
                        value={formData[field.name] || ""}
                        onChange={handleChange}
                        type={field.type}
                        options={field.options}
                        rows={field.rows}
                        error={errors[field.name]}
                        helperText={errors[field.name]}
                      />
                    )}
                  </Grid>
                ))}
                <Grid mx="auto" item xs={12}>
                  <Button
                    fullWidth
                    type="submit"
                    variant="contained"
                    color="primary"
                    style={{ color: "white" }}
                  >
                    {t("Submit")}
                  </Button>
                </Grid>
              </Grid>
            </form>
          </Grid>
        </Container>
      </LoaderContainer>
    </>
  );
}
